import { Resource } from './../builders/resource_builder';
import { ResourceCategory } from './../builders/resource_category_builder';
import * as _4 from 'lodash4';

export class ResourceCategoriesServant {
  static sortByOrderingKey = (aResource: Resource | ResourceCategory, bResource: Resource | ResourceCategory) =>
    aResource.ordering - bResource.ordering;

  static getResourcesForCategory(category: ResourceCategory, resources: Resource[]) {
    return resources
      .filter((resource) => resource.category === category.id)
      .sort(ResourceCategoriesServant.sortByOrderingKey);
  }

  static getCategories(categories: ResourceCategory[], resources: Resource[]) {
    return categories.sort(ResourceCategoriesServant.sortByOrderingKey).map((category) => ({
      id: category.id,
      name: category.name,
      isSelected: category.isSelected,
      ordering: category.ordering,
      resources: ResourceCategoriesServant.getResourcesForCategory(category, resources)
    }));
  }

  static getNonEmptyCategories(categories: ResourceCategory[], resources: Resource[]) {
    return this.getCategories(categories, resources).filter((category) => !_4.isEmpty(category.resources));
  }
}



// WEBPACK FOOTER //
// ./app/lib/resources/servants/resource_categories_servant.ts